import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { formatNumber } from '@/lib/utils';

interface Props {
  porTipo: Array<{ tipo: string; total: number; en_bodega: number }>;
  loading?: boolean;
}

export function InventarioBreakdown({ porTipo, loading }: Props) {
  const maxTotal = Math.max(...porTipo.map((t) => t.total), 1);
  const visibles = porTipo.slice(0, 8);

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-base">Inventario por tipo</CardTitle>
        <CardDescription>Distribución del catálogo según categoría</CardDescription>
      </CardHeader>
      <CardContent>
        {loading ? (
          <div className="space-y-3">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="skeleton h-8 rounded" />
            ))}
          </div>
        ) : visibles.length === 0 ? (
          <p className="text-sm text-muted-foreground text-center py-8">Sin datos disponibles</p>
        ) : (
          <ul className="space-y-3">
            {visibles.map((row) => {
              const pct = (row.total / maxTotal) * 100;
              const stockBajo = row.en_bodega <= 3;
              return (
                <li key={row.tipo} className="group">
                  <div className="flex items-baseline justify-between gap-3 mb-1.5">
                    <div className="flex items-center gap-2 min-w-0">
                      <p className="text-sm font-medium text-foreground truncate capitalize">
                        {row.tipo.toLowerCase()}
                      </p>
                      {stockBajo && row.en_bodega > 0 && (
                        <Badge variant="warn" className="text-[10px]">Stock bajo</Badge>
                      )}
                      {row.en_bodega === 0 && (
                        <Badge variant="danger" className="text-[10px]">Sin stock</Badge>
                      )}
                    </div>
                    <div className="text-xs text-muted-foreground shrink-0 tabular">
                      <span className="font-semibold text-foreground">{formatNumber(row.total)}</span>
                      <span className="ml-1">· {formatNumber(row.en_bodega)} disp.</span>
                    </div>
                  </div>
                  <div className="h-1.5 w-full rounded-full bg-muted overflow-hidden">
                    <div
                      className="h-full bg-gradient-to-r from-primary-500 to-primary-700 transition-all duration-700"
                      style={{ width: `${pct}%` }}
                    />
                  </div>
                </li>
              );
            })}
          </ul>
        )}
      </CardContent>
    </Card>
  );
}
